import { create } from 'zustand';
import { Message } from '@/Domain/api/Conversation/dto/Message.dto';

interface ConversationStore {
  activeMessage: Message | null;
  setMessage: (activeMessage: Message | null) => void;
}

export const useConversationStore = create<ConversationStore>((set) => ({
  activeMessage: null,
  setMessage: (activeMessage) => set(() => ({ activeMessage: activeMessage })),
}));
